import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { DeviceService } from '@core/services/app/device.service';

@Directive({
  selector: '[appAutoFocus]',
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(
    private readonly host: ElementRef,
    private readonly deviceService: DeviceService,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.host.nativeElement.focus();
      if (this.deviceService.getDeviceType() === 'mobile') {
        const input = this.host.nativeElement;
        const originalType = input.type;
        input.type = 'text';
        input.focus();
        setTimeout(() => {
          input.type = originalType;
        }, 100);
      }
    }, 300);
  }
}
